import { type CSSProperties } from 'react';
import { divide, multiplication } from '@common/lib/decimal';

type CalcAdaptiveSizeArgs = {
  originSize: {
    width: number;
    height: number;
  };
  parentOrigin: { width: number } | { height: number };
};

const calcAdaptiveSize = ({
  originSize,
  parentOrigin,
}: CalcAdaptiveSizeArgs): CSSProperties => {
  const result: CSSProperties = {
    aspectRatio: `${originSize.width}/${originSize.height}`,
  };

  if ('width' in parentOrigin) {
    const widthInPercentage = divide(
      multiplication(originSize.width, 100),
      parentOrigin.width,
    );

    result.width = `${widthInPercentage.toFixed(2)}%`;
  }

  if ('height' in parentOrigin) {
    const heightInPercentage = divide(
      multiplication(originSize.height, 100),
      parentOrigin.height,
    );

    result.height = `${heightInPercentage.toFixed(2)}%`;
  }

  return result;
};

type CalcAdaptivePositionArgs = {
  originSize: {
    width: number;
    height: number;
  };
  originPosition: {
    x: number;
    y: number;
  };
};

const calcAdaptivePositon = ({
  originSize,
  originPosition,
}: CalcAdaptivePositionArgs): CSSProperties['transform'] => {
  const xInPercentage = divide(
    multiplication(originPosition.x, 100),
    originSize.width,
  );
  const yInPercentage = divide(
    multiplication(originPosition.y, 100),
    originSize.height,
  );

  const result = `translate(${xInPercentage.toFixed()}%, ${yInPercentage.toFixed(2)}%)`;

  return result;
};

export { calcAdaptivePositon, calcAdaptiveSize };
